import clsx from "clsx";
import React, { type JSX } from "react";
import { MdCheckBox } from "react-icons/md";
import { MdCheckBoxOutlineBlank } from "react-icons/md";

import { LoadingSkeleton } from "../../LoadingSkeleton";

import "./styles.css";

interface Props {
  field: string;
  label?: string | React.ReactNode;
  disabled?: boolean;
  errorMessage?: string;
  children?: React.ReactNode;
  onChange?: () => void;
  value?: boolean;
  className?: string;
  loadingValue?: boolean;
}

export const InputCheckbox = ({
  field,
  label,
  disabled,
  errorMessage,
  children,
  onChange,
  value: checked,
  className,
  loadingValue,
}: Props): JSX.Element => {
  if (loadingValue) {
    return <LoadingSkeleton kind="paragraph" />;
  }

  return (
    <div className={clsx("input-checkbox flex w-fit flex-col", className)}>
      <input
        id={field}
        className="m-0 h-0 w-0 opacity-0"
        type="checkbox"
        disabled={disabled}
        checked={checked}
        onChange={onChange}
      />

      <div className="flex items-center">
        <label
          htmlFor={field}
          className={clsx(
            "relative flex min-h-[20px] items-center",
            disabled ? "disabled opacity-50" : "cursor-pointer",
          )}
        >
          {checked ? (
            <MdCheckBox size="1.5rem" className="icon min-w-3 rounded-sm text-base-black" />
          ) : (
            <MdCheckBoxOutlineBlank size="1.5rem" className="icon min-w-3 rounded-sm text-base-black" />
          )}

          <span className="ml-1">{label}</span>
        </label>

        {children}
      </div>

      {errorMessage && <span className="mt-0.5 text-feedback-error">{errorMessage}</span>}
    </div>
  );
};
